import type { LoaderFunctionArgs } from '@remix-run/node';
import { getArticleTiles } from '~/modules/article/api/get-article-tiles.server';

export const loader = async (args: LoaderFunctionArgs) => {
    return await getArticleTiles(args);
};

export const HREF_ARTICLE_TILES = '/remix-api/article/get-article-tiles';
